module.exports = __webpack_public_path__ + "img/temp.d1d7f2c0.jpg";